// Full TpT catalog from https://www.teacherspayteachers.com/store/embracethemagicofwords (35 products)
// Categories are used by the landing page filter chips (counts computed dynamically from products).

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "bundles", label: "Bundles & FREE" },
  { id: "vocabulary", label: "Vocabulary & Word Study" },
  { id: "wh", label: "WH Questions & Comprehension" },
  { id: "grammar", label: "Grammar & Parts of Speech" },
  { id: "adjectives", label: "Adjectives & Strong Verbs" },
  { id: "sentences", label: "Sentence Writing & Editing" },
  { id: "synonyms", label: "Synonyms & Antonyms" },
];

// eslint-disable-next-line
export const TPT_PRODUCTS = [
  // ── Featured / Bestsellers ──────────────────────────────────
  {
    id: "8636092",
    title: "Comprehensive Vocabulary Bundle — Antonyms, Synonyms, Tenses & Plurals",
    grades: "K–5th",
    price: "$92.46",
    originalPrice: "$135.69",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Trace-and-learn-words-the-fun-way--8636092-1789115487/original-8636092-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Comprehensive-Vocabulary-Bundle-AntonymsSynonymsTenses-Plurals-K-5th-Grade-8636092",
    category: "bundles",
    featured: true,
    description: "31-resource Mega Bundle — the complete tracing + skill collection for K-5, SPED, ESL/ELL, homeschool, OT.",
  },
  {
    id: "15481287",
    title: "Synonym Tracing Bundle | 45 + 100 Words",
    grades: "K–5th",
    price: "$11.99",
    originalPrice: "$15.05",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Synonym-Tracing-Bundle-45-100-Words-K-5-SPED-ESL-15481287-1780045005/original-15481287-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Synonym-Tracing-Bundle-45-100-Words-K-5th-Grade-SPED-ESL-15481287",
    category: "bundles",
    featured: true,
    description: "286 pages, 145 vocabulary words, hundreds of synonyms — build vocabulary + fine motor skills.",
  },
  {
    id: "15568214",
    title: "Prepositions & Adverbs Tracing Bundle",
    grades: "K–5th",
    price: "$15.28",
    originalPrice: "$16.98",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Prepositions-Adverbs-Tracing-Bundle-Grammar-Fine-Motor-SPED-15568214-1780044532/original-15568214-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Prepositions-Adverbs-Tracing-Bundle-Grammar-Fine-Motor-SPED-K-5th-Grade-15568214",
    category: "bundles",
    description: "Grammar + fine motor: 169+ pages across two complete workbooks.",
  },
  {
    id: "9945066",
    title: "Vocabulary Tracing Worksheets | 5-Product Bundle",
    grades: "K–5th",
    price: "$12.99",
    originalPrice: "$17.55",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Synonyms-Tracing-Worksheet-Bundle--9945066-1780045081/original-9945066-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Vocabulary-Tracing-Worksheets-Build-Vocabulary-K-5th-Grades-No-Prep-9945066",
    category: "bundles",
    description: "5-in-1 Synonyms Mega Bundle — trace, match, write & hands-on practice. Save 25%.",
  },

  // ── WH Questions ────────────────────────────────────────────
  {
    id: "16617844",
    title: "WH Questions Worksheets Level 2 | Sentence Writing & Grammar",
    grades: "2nd–4th",
    price: "$9.99",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/WH-Questions-Worksheets-Level-2-Sentence-Writing-Grammar-Gr-2nd-4th-16617844-1782217429/original-16617844-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/WH-Questions-Worksheets-Level2-Sentence-Writing-Grammar-Grade-2nd-4th-16617844",
    category: "wh",
    featured: true,
    description: "3-stage scaffold (Learn → Try → Build), 10 illustrated scenarios, moves kids to independent writing.",
  },
  {
    id: "16568093",
    title: "WH Questions Workbook Level 1 | Who What Where When Why",
    grades: "K–2nd",
    price: "$5.55",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/WH-Questions-Workbook-Level-1-WHO-WHAT-WHERE-WHEN-WHY-Grades-K-2nd-16568093-1780781108/original-16568093-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/WH-Questions-Workbook-Level-1-WHO-WHAT-WHERE-WHEN-WHY-Grades-K-2nd-16568093",
    category: "wh",
    description: "K–2 learners get a visual, confidence-building path through the five foundational question words.",
  },

  // ── Sentence Writing & Editing ──────────────────────────────
  {
    id: "16765462",
    title: "Fix the Sentence Workbook | Grammar Editing & Vocabulary",
    grades: "2nd–5th",
    price: "$6.99",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Fix-the-Sentence-Workbook-Grammar-Editing-Vocabulary-Practice-2nd-5th-Gr-16765462-1782148025/original-16765462-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Fix-the-Sentence-Workbook-Grammar-Editing-Vocabulary-Practice-2nd-5th-Gr-16765462",
    category: "sentences",
    description: "50-page grammar + vocabulary editing workbook — 25 words × 2 pages, made for kids who learn differently.",
  },
  {
    id: "16524163",
    title: "Building Sentences Workbook | Vocabulary + Grammar",
    grades: "3rd–5th",
    price: "$6.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Building-Sentences-Workbook-Vocabulary-Grammar-3rd-5th-Grades-16524163-1781456609/original-16524163-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Building-Sentences-Workbook-Vocabulary-Grammar-3rd-5th-Grades-16524163",
    category: "sentences",
    description: "22 words with 3 sentence-building patterns each — colour-coded word banks, trace-and-write handwriting.",
  },

  // ── Adjectives & Strong Verbs ───────────────────────────────
  {
    id: "17608841",
    title: "Weak to Strong Verbs Workbook — Precise Verb Choice",
    grades: "2nd–3rd",
    price: "$5.25",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Weak-to-Strong-Verbs-Workbook-Precise-Verb-Choice-2nd-3rd-Grades-SPED-ESL-17608841-1788896075/original-17608841-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Weak-to-Strong-Verbs-Workbook-Precise-Verb-Choice-2nd-3rd-Grades-SPED-ESL-17608841",
    category: "adjectives",
    description: "Swap said, went, looked, ate, laughed, cried, held, threw for 4 precise strong-verb alternatives each.",
  },
  {
    id: "17625873",
    title: "Weak to Strong Adjectives Workbook — Precise Word Choice",
    grades: "2nd–3rd",
    price: "$5.25",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Weak-to-Strong-Adjectives-Workbook-Precise-Word-Choice2nd-3rd-Grades-SPED-ESL-17625873-1789082776/original-17625873-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Weak-to-Strong-Adjectives-Workbook-Precise-Word-Choice2nd-3rd-GradesSPED-ESL-17625873",
    category: "adjectives",
    description: "8 weak adjectives (Good, Bad, Big, Small, Happy, Sad, Nice, Scared) → strong, powerful alternatives.",
  },
  {
    id: "17530264",
    title: "Action Verbs Workbook — Strong Verbs Vocabulary Practice",
    grades: "2nd–3rd",
    price: "$3.75",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Action-Verbs-Workbook-Strong-Verbs-Vocabulary-Practice-2nd-Grade-3rd-SPED-ESL-17530264-1788099933/original-17530264-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Action-Verbs-Workbook-Strong-Verbs-Vocabulary-Practice2nd-Grade-3rdSPED-ESL-17530264",
    category: "adjectives",
    description: "6 everyday action verbs — SIGHED, WONDERED, FROLIC, EMBRACE, PRANCED, BANISH — 2-page spread each.",
  },
  {
    id: "16515204",
    title: "Adjectives Worksheets | Level 1 | Trace & Write",
    grades: "2nd–3rd",
    price: "$4.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Adjectives-Worksheets-Trace-Write-2nd-3rd-Grade-SPED-ESL-16515204-1780302372/original-16515204-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Adjectives-Worksheets-Level-1-Trace-Write-2nd3rd-Grade-SPED-ESL-16515204",
    category: "adjectives",
    description: "6 essential adjectives through tracing, writing, matching, and building original sentences.",
  },
  {
    id: "16523408",
    title: "Adjectives Vocabulary Workbook | Level 2 | Trace, Fill-in-Blank",
    grades: "4th–5th",
    price: "$4.00",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Adjectives-Vocabulary-Workbook-Level-2-Trace-Fill-in-Blank-Grades-4th-5th-16523408-1780333592/original-16523408-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Adjectives-Vocabulary-Workbook-Level-2-Trace-Fill-in-Blank-Grades-4th-5th-16523408",
    category: "adjectives",
    description: "6 high-impact adjectives for upper elementary — tracing, fill-in-blank, synonym matching, writing.",
  },
  {
    id: "16523692",
    title: "Strong Verbs Vocabulary Workbook | Level 1",
    grades: "2nd–3rd",
    price: "$4.00",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Strong-Verbs-Vocabulary-Workbook-Level-1-Trace-Fill-in-Blank-2nd-3rd-Grade-16523692-1780335630/original-16523692-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Strong-Verbs-Vocabulary-Workbook-Level-1-Trace-Fill-in-Blank2nd-3rd-Grade-16523692",
    category: "adjectives",
    description: "6 vivid expressive verbs — beyond “said” and “went” — scaffolded practice for SPED, ESL, OT.",
  },
  {
    id: "16523932",
    title: "Strong Verbs Vocabulary Workbook | Level 2",
    grades: "4th–5th",
    price: "$4.00",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Strong-Verbs-Vocabulary-Workbook-Level-2-Trace-Fill-in-Blank-4th-5th-Grade-16523932-1780337716/original-16523932-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Strong-Verbs-Vocabulary-Workbook-Level-2-Trace-Fill-in-Blank4th-5th-Grade-16523932",
    category: "adjectives",
    description: "7 sophisticated action verbs that transform upper-elementary writing.",
  },

  // ── Grammar & Parts of Speech ───────────────────────────────
  {
    id: "15491294",
    title: "Adverbs Tracing Worksheets | Grammar K–5",
    grades: "K–5th",
    price: "$9.99",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Adverbs-Tracing-Worksheets-Grammar-K-5-SPED-ESL-ELL-OT-15491294-1780044564/original-15491294-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Adverbs-Tracing-Worksheets-Grammar-K-5th-Grade-SPED-ESL-ELL-OT-15491294",
    category: "grammar",
    description: "107 pages — master 35 essential adverbs (HOW, WHEN, WHERE, HOW OFTEN) with everyday sentences.",
  },
  {
    id: "15490428",
    title: "Prepositions Worksheets | Tracing Grammar",
    grades: "K–5th",
    price: "$6.99",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Prepositions-Worksheets-Tracing-Grammar-K-5-SPED-ESL-OT-15490428-1780044596/original-15490428-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Prepositions-Worksheets-Tracing-Grammar-K-5th-Grade-SPED-ESL-OT-15490428",
    category: "grammar",
    description: "62 pages — 35 essential prepositions with WHERE, WHEN, and HOW hands-on tracing.",
  },
  {
    id: "8642857",
    title: "Singular & Plural Nouns Tracing Worksheets | 45+ Plurals",
    grades: "1st–4th",
    price: "$4.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Trace-and-learn-plurals-8642857-1780045175/original-8642857-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Singular-Plural-Nouns-Tracing-Worksheets-45-Plurals-Grades-1st-4th-8642857",
    category: "grammar",
    description: "45+ plural forms — 17-page workbook, print-and-go, PDF + editable DOCX.",
  },
  {
    id: "8642325",
    title: "Masculine & Feminine Nouns Tracing | 46 Gender Nouns",
    grades: "2nd–4th",
    price: "$4.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Trace-and-Master-Feminine-and-Masculine-Gender-Nouns-8642325-1773600565/original-8642325-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Masculine-Feminine-Nouns-Tracing-Worksheets-46-Gender-Nouns-Grammar-Grades-8642325",
    category: "grammar",
    description: "46 gender noun pairs organized into 6 logical categories for easier learning.",
  },
  {
    id: "8651406",
    title: "Verb Tenses Tracing Worksheets | Present Past Future",
    grades: "2nd–4th",
    price: "$3.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Trace-and-learn-all-the-tenses-in-English-8651406-1777836346/original-8651406-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Verb-Tenses-Tracing-Worksheets-Present-Past-Future-Grammar-Handwriting-8651406",
    category: "grammar",
    description: "Master present, past, and future verb tenses through kinesthetic tracing practice.",
  },
  {
    id: "9742672",
    title: "Functional Words: Synonyms & Antonyms | Vocabulary",
    grades: "2nd–4th",
    price: "$4.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Functional-Words-9742672-1780068517/original-9742672-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Functional-Words-Synonyms-Antonyms-Vocabulary-Worksheets-Grades-2nd-4th-9742672",
    category: "grammar",
    featured: true,
    description: "5 essential functional words through synonyms + antonyms practice, tracing, matching.",
  },
  {
    id: "15328286",
    title: "Functional Words: Verbs Synonyms & Antonyms",
    grades: "2nd–4th",
    price: "$4.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Functional-Words-Verbs-Synonyms-Antonyms-Vocabulary-Worksheets-Grades-2-4-15328286-1780044846/original-15328286-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Functional-WordsVerbs-Synonyms-Antonyms-Vocabulary-Worksheets-Gr-2nd-4th-15328286",
    category: "grammar",
    description: "6 essential verbs through synonyms + antonyms, traceable text, sentence writing, matching.",
  },

  // ── Vocabulary & Word Study ─────────────────────────────────
  {
    id: "16216453",
    title: "Vocabulary Workbook for Any Word List",
    grades: "2nd–5th",
    price: "$4.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Vocabulary-Workbook-for-Any-Word-List-ELA-SPED-ESL-Homeschool-96-Worksheets-16216453-1780043803/original-16216453-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Vocabulary-Workbook-for-Any-Word-List-ELA-SPED-ESL-Homeschool-2nd-5th-Grade-16216453",
    category: "vocabulary",
    description: "One structured space to truly learn every vocabulary word — from definition to context. Works with ANY list.",
  },
  {
    id: "8887350",
    title: "100 Synonyms Tracing Workbook",
    grades: "2nd–5th",
    price: "$8.99",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/100-Words-and-their-synonyms-taken-from-Charlotte-s-Web-chapters-1-8-8887350-1781081197/original-8887350-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/100-Synonyms-Tracing-Workbook-Grades-2nd-5th-SPED-ESL-8887350",
    category: "vocabulary",
    description: "100 essential words + 400 synonyms — definition, tracing, and repetition-based practice.",
  },
  {
    id: "8695514",
    title: "Synonym Tracing Worksheets | 45 Words",
    grades: "K–5th",
    price: "$6.06",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Vocabulary-booster-Synonyms-8695514-1773427848/original-8695514-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Synonym-Tracing-Worksheets-45-Words-K-5-SPED-ESL-8695514",
    category: "vocabulary",
    description: "45 words × synonym tracing — strengthen vocabulary, fine motor, and reading comprehension.",
  },

  // ── Synonyms & Antonyms ─────────────────────────────────────
  {
    id: "15238873",
    title: "Synonyms Tracing Worksheets | Strong Synonyms",
    grades: "2nd–3rd",
    price: "$1.99",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Strong-Synonyms-Worksheets-Vocabulary-Activities-Grades-2-3-ELA-Printable-15238873-1780045043/original-15238873-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Synonyms-Tracing-Worksheets-Vocabulary-Fine-Motor-SPED-ESL-Grades-2nd-3rd-15238873",
    category: "synonyms",
    description: "8 everyday words → strong synonym alternatives across a 6-page workshop.",
  },
  {
    id: "8688060",
    title: "Synonym Worksheets Vocabulary Activities Workbook",
    grades: "K–3rd",
    price: "$5.99",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/25-Words-with-4-synonyms-each-That-is-100-words-for-the-weekend--8688060-1780045143/original-8688060-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Synonym-Worksheets-Vocabulary-Activities-Grades-K-3rd-Workbook-8688060",
    category: "synonyms",
    description: "25 words × 4 synonyms each — 78-page workbook for K–3 with tracing + matching + fill-in-blank.",
  },
  {
    id: "8677139",
    title: "Synonym Workbook | Trace, Match, Write",
    grades: "2nd–5th",
    price: "$3.50",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Trace-and-learn-synonyms-8677139-1768331876/original-8677139-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Synonym-Workbook-Trace-Match-Write-Vocabulary-Building-Word-Power-8677139",
    category: "synonyms",
    description: "12-page workbook combining vocabulary building with light-gray traceable text.",
  },
  {
    id: "8633765",
    title: "Opposites to Explore | Antonyms by Category",
    grades: "2nd–4th",
    price: "$4.40",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Trace-and-learn-Antonymns-8633765-1778181990/original-8633765-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Opposites-to-Explore-Antonyms-by-Category-Tracing-Worksheets-Grades-K-4-8633765",
    category: "synonyms",
    description: "44 antonym pairs, themed and neurodiversity-affirming.",
  },
  {
    id: "8635735",
    title: "Everyday Synonyms: Tracing Worksheets",
    grades: "K–4th",
    price: "$2.00",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Functional-Synonyms-for-everyday-use-8635735-1777913686/original-8635735-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Everyday-Synonyms-Tracing-Worksheets-Vocabulary-Building-Grades-K-4-8635735",
    category: "synonyms",
    description: "20 powerful synonym pairs — 23-page workbook for K-4.",
  },

  // ── FREE Downloads ──────────────────────────────────────────
  {
    id: "15596502",
    title: "Vocabulary Context Clues Worksheets | Synonyms & Antonyms",
    grades: "2nd–4th",
    price: "FREE",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Vocabulary-Context-Clues-Tracing-Worksheets-Synonyms-Antonyms-SPED-ESL-ELL-OT-15596502-1775945981/original-15596502-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Vocabulary-Context-Clues-Worksheets-Synonyms-Antonyms-FREE-SPED-ESL-15596502",
    category: "bundles",
    free: true,
    description: "Free context-clues worksheet — perfect for SPED, ESL/ELL, intervention.",
  },
  {
    id: "8634187",
    title: "Tracing Worksheet for Synonyms",
    grades: "PreK–3rd",
    price: "FREE",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Trace-and-practice-synonyms-8634187-1750250627/original-8634187-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Tracing-Worksheet-for-Synonyms-8634187",
    category: "synonyms",
    free: true,
    description: "Free intro to synonyms — simple layouts to build word understanding.",
  },
  {
    id: "8630115",
    title: "Simple Handwriting Worksheets",
    grades: "PreK–3rd",
    price: "FREE",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Simple-Handwriting-worksheets-8630115-1768078034/original-8630115-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Simple-Handwriting-worksheets-8630115",
    category: "bundles",
    free: true,
    description: "Free fun handwriting worksheets to support your child’s writing journey.",
  },
  {
    id: "8642034",
    title: "Hone Your Antonym Skills",
    grades: "1st–3rd",
    price: "FREE",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Practice-Antonyms-8642034-1781977551/original-8642034-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Hone-Your-Antonym-Skills-8642034",
    category: "synonyms",
    free: true,
    description: "Free antonym worksheet — write the opposites for each provided word.",
  },
  {
    id: "8643109",
    title: "Write the Plural Forms (Answer Key Included)",
    grades: "1st–3rd",
    price: "FREE",
    image: "https://ecdn.teacherspayteachers.com/thumbitem/Write-the-Plurals-Answer-Key-provided--8643109-1781978871/original-8643109-1.jpg",
    link: "https://www.teacherspayteachers.com/Product/Write-the-plural-forms-Answer-key-included-8643109",
    category: "grammar",
    free: true,
    description: "Free plural forms practice — with a full answer key included.",
  },
];
